'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _bidder = require('./remote/bidder');

var Bidder = {
    fetchBidderData: function fetchBidderData(params) {
        return _bidder.BidderRemote.fetchBidderData(params);
    },
    postCompleteAccount: function postCompleteAccount(params) {
        return _bidder.BidderRemote.postCompleteAccount(params);
    },
    postCreateAccount: function postCreateAccount(params) {
        return _bidder.BidderRemote.postCreateAccount(params);
    },
    postLogin: function postLogin(params) {
        return _bidder.BidderRemote.postLogin(params);
    },
    postSetPassword: function postSetPassword(params) {
        return _bidder.BidderRemote.postSetPassword(params);
    }
};

exports.default = Bidder;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/bidder.js
// module id = Hwmz
// module chunks = 46